import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <span className="text-background-50 font-heading font-bold text-sm">90</span>
                </div>
                <span className="font-heading font-bold text-xl text-background-50">90影视</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                高清超清4K蓝光1080P画质电影电视剧免费在线观看不缓冲全集，极致视觉体验尽在90影视。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">影视分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-accent-500 cursor-pointer transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-accent-500 cursor-pointer transition-colors whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-accent-500 cursor-pointer transition-colors whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <a href="/about#contact" className="text-sm text-background-400 hover:text-accent-500 cursor-pointer transition-colors whitespace-nowrap">联系我们</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-accent-500 mt-0.5"></i>
                  <span className="text-sm text-background-400">contact@90yingshi.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-accent-500 mt-0.5"></i>
                  <span className="text-sm text-background-400">400-888-9090</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-accent-500 mt-0.5"></i>
                  <span className="text-sm text-background-400">北京市朝阳区影视产业园区</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">© 2026 90影视 版权所有 | 京ICP备20260803001号</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-accent-500 cursor-pointer transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-accent-500 cursor-pointer transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-accent-500 cursor-pointer transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}